import { render, staticRenderFns } from "./logoutsvg.vue?vue&type=template&id=b71fa9b8"
import script from "./logoutsvg.vue?vue&type=script&lang=js"
export * from "./logoutsvg.vue?vue&type=script&lang=js"
import style0 from "./logoutsvg.vue?vue&type=style&index=0&id=b71fa9b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports